import { render, staticRenderFns } from "./CardEditModal.vue?vue&type=template&id=45c6a948&"
import script from "./CardEditModal.vue?vue&type=script&lang=ts&"
export * from "./CardEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports